export default {
  title: 'Szybkie akcje',
  send_push_notification: {
    label: 'Wyślij powiadomienie push',
    description: 'Utwórz nową kampanię',
  },
  email_campaign: {
    label: 'Kampania e-mailowa',
    description: 'Wyślij do subskrybentów',
  },
  view_analytics: {
    label: 'Zobacz analizy',
    description: 'Wydajność kampanii',
  },
};
